import { Button, Text } from '@belong/ui';
import clsx from 'clsx';
import { ApplicationDetails } from 'src/api/models';
import { MobileBottomBar } from 'src/components/mobile-bottom-bar/mobile-bottom-bar';
import { GET_STARTED_STRINGS } from '../get-started.strings';

type ActionButtons = {
  shouldShowResumeApplicationButton: boolean;
  onResumeApplicationPress: () => void;
  existingApplications?: ApplicationDetails[];
  selectedApplication?: ApplicationDetails;
  onStartNewApplicationPress: () => void;
};

export function ActionButtons({
  shouldShowResumeApplicationButton,
  onResumeApplicationPress,
  existingApplications = [],
  selectedApplication,
  onStartNewApplicationPress,
}: ActionButtons) {
  const shouldShowUseExistingApplicationButton =
    existingApplications.length > 0;
  return (
    <>
      <div
        className={clsx('mb-2xl mt-xl', {
          // If we are only showing the MobileBottomBar we don't need to display this component
          'hidden md:block':
            !shouldShowResumeApplicationButton &&
            !shouldShowUseExistingApplicationButton,
        })}
      >
        <div className="md:max-w-flow-lg mx-auto flex w-full flex-1 flex-col">
          {shouldShowResumeApplicationButton ? (
            <>
              <Button
                onClick={onStartNewApplicationPress}
                size="auto"
                className="mb-xl"
              >
                {GET_STARTED_STRINGS.start_new_application_button}
              </Button>
              <Button variant="text" onClick={onResumeApplicationPress}>
                {GET_STARTED_STRINGS.resume_application_button}
              </Button>
            </>
          ) : (
            <>
              {shouldShowUseExistingApplicationButton ? (
                <>
                  <div className="my-md relative flex w-full items-center justify-center">
                    <div className="border-gray absolute left-0 top-1/2 h-px w-full border border-dashed" />
                    <Text className="p-xs text-gray relative z-10 self-start bg-white">
                      Or
                    </Text>
                  </div>
                  <Button onClick={onStartNewApplicationPress} variant="text">
                    {GET_STARTED_STRINGS.start_new_application_button}
                  </Button>
                </>
              ) : (
                <Button
                  onClick={onStartNewApplicationPress}
                  size="auto"
                  className="hidden md:inline-block"
                >
                  {GET_STARTED_STRINGS.start_new_application_button}
                </Button>
              )}
            </>
          )}
        </div>
      </div>
      {!shouldShowResumeApplicationButton &&
        !shouldShowUseExistingApplicationButton && (
          <MobileBottomBar
            nextText={
              shouldShowUseExistingApplicationButton
                ? selectedApplication?.basicInfo?.status === 'Started'
                  ? GET_STARTED_STRINGS.continue_existing_application_button
                  : GET_STARTED_STRINGS.use_existing_application_button
                : GET_STARTED_STRINGS.start_new_application_button
            }
            onNext={() => onStartNewApplicationPress()}
            disabled={
              shouldShowUseExistingApplicationButton && !selectedApplication
            }
          />
        )}
    </>
  );
}
